


































import {
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { formatCurrency } from "@/shared/currency";
import { usePreferencesStore } from "@/employee/store/preferences";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class ElectronicStatementConsent extends Vue {
  preferencesStore = usePreferencesStore();
  custodianSettingsStore = useCustodianSettingsStore();

  consentedToEStatement: boolean = null;
  isSubmitting: boolean;

  get loading () {
    return !this.preferencesStore.preferencesLoaded;
  }

  mounted () {
    this.preferencesStore.loadPreferences();

    if (this.preferencesStore.preferencesLoaded) { // happens in page back/foward scenarios
      this.onUsePaperStatementsChange(this.preferencesStore.usePaperStatements);
    }
  }

  @Watch("preferencesStore.usePaperStatements")
  onUsePaperStatementsChange (usePaper) {
    this.consentedToEStatement = !usePaper;
  }

  get quarterlyPaperStatementFeeString () {
    return `${formatCurrency(this.custodianSettingsStore.quarterlyPaperStatementFee)}`;
  }

  onSubmit () {
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      this.preferencesStore.setPreferences({
        paperStatement: !this.consentedToEStatement
      }).then(_ => {
        this.$emit("complete");
      }).finally(() => {
        this.isSubmitting = false;
      });
    }
  }
}
